import { SVGProps, memo } from 'react';

function SvgComponent({ className = '', opacity = 0.7, ...rest }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width='36'
      height='23'
      viewBox='0 0 40 26'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      {...rest}
    >
      {/* Vehicle body */}
      <rect
        x='1'
        y='1'
        width='38'
        height='24'
        rx='1.5'
        stroke='currentColor'
        strokeWidth='1'
        fill='none'
      />
      {/* Top arrowhead */}
      <polygon points='20,3 16,10 24,10' fill='currentColor' opacity={opacity} />
      {/* Shaft */}
      <line x1='20' y1='10' x2='20' y2='16' stroke='currentColor' strokeWidth='1.5' opacity={opacity} />
      {/* Bottom arrowhead */}
      <polygon points='20,23 16,16 24,16' fill='currentColor' opacity={opacity} />
    </svg>
  );
}

const CrabSetting90 = memo(SvgComponent);
export default CrabSetting90;
